/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Sunday, May 8th 2022, 6:58:58 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { StyledOSDialog, StyledOSDialogProps } from "ui-widgets";
import { OSForm, OSFormProps } from "ui-widgets/forms";

type OSPopUpFormProps<TFormData> = OSFormProps<TFormData> &
  Pick<StyledOSDialogProps, "open" | "onClose" | "popUpTitle" | "popUpIcon">;

export const OSPopUpForm = <TFormData,>(props: OSPopUpFormProps<TFormData>) => {
  const { open, onClose, popUpTitle, popUpIcon, ...formProps } = props;

  return (
    <StyledOSDialog open={props.open} onClose={props.onClose} popUpTitle={props.popUpTitle} popUpIcon={props.popUpIcon}>
      <OSForm {...formProps} />
    </StyledOSDialog>
  );
};
